import { Lightbulb, FileText } from 'lucide-react';
import { Link } from 'react-router-dom';
import { SummaryPanel } from './SummaryPanel';
import { summaryAmount, summaryDate, solesAmount } from './formatters';

export const CommercialSummary = ({ sections, currency, meeting }) => {
    const crm = sections.opportunities.data;
    const budgets = sections.budgets.data;
    return <>
        <SummaryPanel id="home-opportunities" title="Oportunidades y CRM" icon={Lightbulb} href="/crm"
            question="¿Cómo viene la captación de nuevos negocios?" section={sections.opportunities}>
            {crm && <>
                <div className="home-week-numbers"><div><strong>{crm.count}</strong><small>Oportunidades abiertas</small></div>
                    <div><strong>{summaryAmount(crm.amount, currency)}</strong><small>Monto potencial sin ponderar</small></div></div>
                <p className="home-week-strip">{crm.new_count} oportunidades abiertas creadas en los últimos 7 días.</p>
                <p className="home-week-strip"><b>Hasta el domingo:</b> {crm.followups} actividades por hacer · {crm.overdue} vencidas.</p>
                {crm.next.length ? <details open={meeting || undefined} key={`crm-${meeting}`}>
                    <summary>Próximos pasos comerciales</summary>
                    <ul className="home-week-list">{crm.next.map(item => <li key={item.id}>
                        <span>{item.nombre}</span><small>{item.referencia || 'Oportunidad'} · {item.responsible} · {summaryDate(item.due)}</small>
                    </li>)}</ul></details> : <p className="home-week-empty">Sin actividades próximas. Programa el siguiente contacto en Oportunidades.</p>}
            </>}
        </SummaryPanel>
        <SummaryPanel id="home-budgets" title="Presupuestos y cotizaciones" icon={FileText} href="/ppto?from=inicio"
            question="¿Qué propuestas pueden convertirse en proyectos?" section={sections.budgets}>
            {budgets && <>
                <div className="home-week-numbers"><div><strong>{budgets.count}</strong><small>Por aprobar</small></div>
                    <div><strong>{solesAmount(budgets.amount)}</strong><small>Monto neto pendiente de aprobación · en soles</small></div></div>
                <p className="home-week-strip"><b>Últimos 7 días:</b> {budgets.created} creados · {budgets.approved} aprobados.</p>
                <p className="home-week-hint">“Por aprobar” incluye propuestas en preparación y pendientes de respuesta.</p>
                <p className="home-week-hint">Dólares convertidos al tipo de cambio registrado; sin tipo de cambio válido se usa S/ 3,40.</p>
                {budgets.next.length ? <details open={meeting || undefined} key={`budgets-${meeting}`}>
                    <summary>Propuestas para revisar</summary><ul className="home-week-list">{budgets.next.map(item => <li key={item.id}>
                        <Link to={`/ppto/${item.id}`}>{item.referencia || 'Sin referencia'}</Link>
                        <small>{solesAmount(item.amount)} · Vigencia: {summaryDate(item.due)}</small>
                    </li>)}</ul></details> : <p className="home-week-empty">No tienes presupuestos por aprobar.</p>}
            </>}
        </SummaryPanel>
    </>;
};
